import { Store } from 'src/store/index';

const shouldDisplayUpsellBeforeAddToBasket = (store: Store) => !store.upsell.isBeforeAddToBasketUpsellWasShown;

export default shouldDisplayUpsellBeforeAddToBasket;
